module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/clubpilates-f67a35a7b7529b90d24151bafb710a04.png";